import axios from "axios";

const Login_Api = axios.create({
  baseURL: "https://api.simplaxi.com/api/login/",
});

export default Login_Api;
